import { render, staticRenderFns } from "./TotalizadorDashCoordenador.vue?vue&type=template&id=98b670cc"
import script from "./TotalizadorDashCoordenador.vue?vue&type=script&lang=js"
export * from "./TotalizadorDashCoordenador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports